// extracted by mini-css-extract-plugin
export default {"add-icon-inner":"manage-users_component_add-icon-inner__zt9Tt","add-icon-outer":"manage-users_component_add-icon-outer__fHj6j"};